'use client';

import { type Dispatch, type SetStateAction } from 'react';

import { Modal, ModalButton, BaseModalContent } from '@/components/modal';

type AdblockModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  onCancel?: () => void;
};

export const AdblockModal = ({
  isModalOpen = false,
  setIsModalOpen,
  onCancel,
}: AdblockModalProps) => {
  const description =
    'It appears that you are using an ad blocker. Please disable the ad blocker to manage your cookie preferences.';

  function closeModal() {
    setIsModalOpen(false);
    if (onCancel) {
      onCancel();
    }
  }

  function openModal() {
    setIsModalOpen(true);
  }

  return (
    <Modal
      heading="Ad Blocker Detected"
      description={description}
      isModalOpen={isModalOpen}
      openModal={openModal}
    >
      <BaseModalContent
        buttonComponent={
          <ModalButton
            variant="primary"
            onClick={closeModal}
          >
            Cancel
          </ModalButton>
        }
      />
    </Modal>
  );
};
